let lastScrollPosition = 0;
let debounceTimeout;

function debounce(func, delay) {
  return function (...args) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => func.apply(this, args), delay);
  };
}

function checkScrollPosition() {
  const navIsOpen = document?.querySelector(".navigation-open");
  const navBarHeight = document?.querySelector("#masthead")?.offsetHeight;
  const scrollPosition = window.scrollY;

  if (!navIsOpen) {
    if (scrollPosition > lastScrollPosition) {
      document.body.classList.add("body-scrolled-down");
      document.body.classList.remove("body-scrolled-up");
    } else if (scrollPosition < lastScrollPosition) {
      document.body.classList.add("body-scrolled-up");
      document.body.classList.remove("body-scrolled-down");
    }

    if (scrollPosition > 0) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("body-scrolled-down");
      document.body.classList.remove("body-scrolled-up");
      document.body.classList.remove("scrolled");
    }

    // Check if scrolled past nav bar height
    if (scrollPosition > navBarHeight) {
      document.body.classList.add("scrolledPastHeader");
    } else {
      document.body.classList.remove("scrolledPastHeader");
    }
  } else {
    document.body.classList.add("body-scrolled-up");
  }

  lastScrollPosition = scrollPosition;
}

window.addEventListener("scroll", debounce(checkScrollPosition, 10));

if (document.readyState !== "loading") {
  checkScrollPosition();
} else {
  document.addEventListener("DOMContentLoaded", checkScrollPosition);
}